import { render, staticRenderFns } from "./MailTemplateCreate.vue?vue&type=template&id=b4893e6e&scoped=true&"
import script from "./MailTemplateCreate.vue?vue&type=script&lang=js&"
export * from "./MailTemplateCreate.vue?vue&type=script&lang=js&"
import style0 from "./MailTemplateCreate.vue?vue&type=style&index=0&id=b4893e6e&lang=scss&scoped=true&"
import style1 from "./MailTemplateCreate.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4893e6e",
  null
  
)

export default component.exports